import { render, staticRenderFns } from "./XInput.vue?vue&type=template&id=c1a64d36&scoped=true&"
import script from "./XInput.vue?vue&type=script&lang=js&"
export * from "./XInput.vue?vue&type=script&lang=js&"
import style0 from "./XInput.vue?vue&type=style&index=0&id=c1a64d36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a64d36",
  null
  
)

export default component.exports